module.exports = __webpack_public_path__ + "79a79ea6dbff79c8be9122b5e09f1c99.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/IMG_1428.jpg
// module id = 59
// module chunks = 0